import { render, staticRenderFns } from "./ad_group.vue?vue&type=template&id=20c9675d&scoped=true"
import script from "./ad_group.vue?vue&type=script&lang=js"
export * from "./ad_group.vue?vue&type=script&lang=js"
import style0 from "./ad_group.vue?vue&type=style&index=0&id=20c9675d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c9675d",
  null
  
)

export default component.exports